// console.log('product page js');

qauntityChange = () => {
    let plusItem = document.querySelector(".qty-selector-wrap .qty_wrap .qty-plus");
    let minusItem = document.querySelector(".qty-selector-wrap .qty_wrap .qty-min");

    if(plusItem){
        plusItem.addEventListener("click",(e)=>{
            // debugger;
            console.log('plus');
            let that = e.currentTarget;
            let parent = that.closest('.qty-selector-wrap');
            let target = document.querySelector('.product_qty_num',parent);
            
            let value = parseInt(target.value) + 1;
            target.value = value;

        });
    }

    if(minusItem){
        minusItem.addEventListener("click",(e)=>{
            console.log('minus');
            let that = e.currentTarget;
            let parent = that.closest('.qty-selector-wrap');
            let target = document.querySelector('.product_qty_num',parent);
            if(target.value > 1){
                let value = parseInt(target.value) - 1;
                target.value = value;
            }
        });
    }
}
qauntityChange();
